export const common = {
  // Navigation
  'nav.features': 'Funksjoner',
  'nav.howItWorks': 'Hvordan det fungerer',
  'nav.pricing': 'Priser',
  'nav.faq': 'FAQ',
  'nav.aboutUs': 'Om oss',
  'nav.getStarted': 'Kom i gang',

  // About Us Section
  'aboutUs.badge': 'Om oss',
  'aboutUs.title': 'Om oss',
  'aboutUs.line1': 'Idéer er billige.',
  'aboutUs.line2': 'Kapital ikke. Tid enda mindre.',
  'aboutUs.paragraph1': 'IdeaOracle.ai ble grunnlagt fordi de fleste forretningsidéer ikke mislykkes på grunn av mangel på mot – men på grunn av mangel på ærlighet. For mye bekreftelse. For lite virkelighet.',
  'aboutUs.belief1a': 'Vi tror ikke på hype.',
  'aboutUs.belief1b': 'Vi tror på markedslogikk.',
  'aboutUs.belief2a': 'Vi tror ikke på motivasjon.',
  'aboutUs.belief2b': 'Vi tror på etterspørsel, konkurranse og differensiering.',
  'aboutUs.mission1': 'Vår oppgave er ikke å få idéer til å se bra ut.',
  'aboutUs.mission2': 'Vår oppgave er å avsløre deres levedyktighet.',
  'aboutUs.analysis': 'IdeaOracle.ai analyserer forretningsnisjer for strukturell markedsmekanikk, realistisk etterspørsel, konkurranseintensitet og gjennomførbarhet. Ikke emosjonelt. Ikke optimistisk. Men nøkternt.',
  'aboutUs.failure1': 'De fleste idéer mislykkes.',
  'aboutUs.failure2': 'Ikke fordi grunnleggere er udyktige –',
  'aboutUs.failure3': 'men fordi ingen var tydelig nok på forhånd.',
  'aboutUs.clarity': 'Vi eksisterer for å levere den klarheten.',
  'aboutUs.value1': 'Ubehagelig.',
  'aboutUs.value2': 'Direkte.',
  'aboutUs.value3': 'Konsekvent.',
  'aboutUs.confirm': 'Hvis en idé har substans, bekrefter vi det.',
  'aboutUs.deny': 'Hvis ikke, sier vi det også.',
  'aboutUs.noApplause': 'Uten applaus.',
  'aboutUs.noSugarcoating': 'Uten forskjønnelse.',
  'aboutUs.noTheater': 'Uten teater.',

  // Hero Section
  'hero.badge': 'Beslutnings-AI for forretningsnisjer',
  'hero.title1': 'Ideer er billige.',
  'hero.title2': 'Dårlige beslutninger er det ikke.',
  'hero.subtitle': 'En AI som evaluerer din forretningsnisje',
  'hero.subtitleLine2': 'før du investerer.',
  'hero.cta': 'Sjekk idé',
  'hero.ctaSecondary': 'Hvordan det fungerer',
  'hero.stat1Value': '30',
  'hero.stat1Label': 'Kreditter per forespørsel',
  'hero.stat2Value': 'Fra 7',
  'hero.stat2Label': 'Vurderingsnivåer',
  'hero.stat3Value': '100%',
  'hero.stat3Label': 'Ærlig og privat',

  // Features Section
  'features.title1': 'Kraftige funksjoner for',
  'features.title2': 'moderne',
  'features.title3': 'bedrifter',
  'features.honestVerdict.title': 'Ærlig dom, ikke en hype-score',
  'features.honestVerdict.description': 'Klare god/middels/svak-verdikter basert på ekte markedsdata og konkurrentanalyse. Ingen 9/10-vurderinger laget for å smigre enhver idé.',
  'features.fullJourney.title': 'Fra idé-sjekk til Builder Report',
  'features.fullJourney.description': 'Valider i chatten, dykk ned i markedsanalysen, eksporter en 25–75-siders Builder Report med personas, økonomi, go-to-market og pitch deck.',
  'features.multilingual.title': '21 språk, lokale markedsdata',
  'features.multilingual.description': 'Fra sveitsisk SMB til solo-grunnlegger i São Paulo — AI svarer på ditt språk, med kilder fra ditt marked.',

  // How It Works
  'howItWorks.title': 'Hvordan det fungerer',
  'howItWorks.subtitle': 'Fire trinn til klarhet om din forretningsnisje.',
  'howItWorks.step1Title': 'Velg en plan',
  'howItWorks.step1Desc': 'Starter, Pro eller Builder – avhengig av dybden i gjennomgangen din.',
  'howItWorks.step2Title': 'Spør AI-en',
  'howItWorks.step2Desc': 'Still spørsmålene dine om nisjen. Hver forespørsel koster 30 kreditter.',
  'howItWorks.step3Title': 'Få ærlig dom',
  'howItWorks.step3Desc': 'AI-en vurderer: God, Middels eller Dårlig. Uten omsvøp.',
  'howItWorks.step4Title': 'Ta en beslutning',
  'howItWorks.step4Desc': 'Nå vet du om det er verdt å gå videre.',

  // Pricing
  'pricing.title': 'Priser',
  'pricing.subtitle': 'Velg planen som passer dybden i gjennomgangen din.',
  'pricing.yearlyDiscount': 'Årsabonnement:',
  'pricing.yearlyDiscountValue': '-20% rabatt',
  'pricing.perMonth': 'per måned',
  'pricing.selectPlan': 'Velg plan',
  'pricing.mostPopular': 'Mest populær',
  'pricing.footer': 'Alle priser i CHF. Kreditter trekkes kun for vellykkede AI-svar.',
  
  // Starter Plan
  'pricing.starter.name': 'Starter',
  'pricing.starter.description': 'For innledende virkelighetstest.',
  'pricing.starter.credits': '2 500 kreditter',
  'pricing.starter.feature1': 'Generer nisjeidé',
  'pricing.starter.feature2': 'Forfin nisje',
  'pricing.starter.feature3': 'Markedsvirkelighetssjekk',
  'pricing.starter.feature4': 'Konkurransevurdering',
  'pricing.starter.feature5': 'Timingvurdering',
  'pricing.starter.feature6': 'Ærlig dom',
  'pricing.starter.feature7': 'Private økter',
  'pricing.starter.feature8': 'Historikk og eksport',

  // Pro Plan
  'pricing.pro.name': 'Pro',
  'pricing.pro.description': 'For dypere gjennomgang.',
  'pricing.pro.credits': '5 000 kreditter',
  'pricing.pro.feature1': 'Alle Starter-funksjoner',
  'pricing.pro.feature2': 'Flere kreditter for intensiv gjennomgang',
  'pricing.pro.feature3': 'Forbedringsforslag',
  'pricing.pro.feature4': 'Alternative nisjer',
  'pricing.pro.feature5': 'Detaljert markedsanalyse',
  'pricing.pro.feature6': 'Prioritert støtte',
  'pricing.pro.feature7': 'Avanserte filtre',
  'pricing.pro.feature8': 'Øktfavoritter',

  // Builder Plan
  'pricing.builder.name': 'Builder',
  'pricing.builder.description': 'Idé → Utviklerbriefing.',
  'pricing.builder.credits': 'Ubegrensede kreditter',
  'pricing.builder.feature1': 'Alle Pro-funksjoner',
  'pricing.builder.feature2': 'Ubegrensede AI-forespørsler',
  'pricing.builder.feature3': 'Builder-modus: Utviklerbriefing',
  'pricing.builder.feature4': 'Strukturert prosjektoversikt',
  'pricing.builder.feature5': 'Brukerflyter og kjernefunksjoner',
  'pricing.builder.feature6': 'Tekniske notater',
  'pricing.builder.feature7': 'Definer ikke-mål',
  'pricing.builder.feature8': 'Fair use-hastighetsbegrensning',
  'pricing.builder.limitNote': 'Fair use-grense',
  'pricing.monthlyReset': 'Månedlig tilbakestilling',

  // Modal
  'pricing.modal.selected': 'valgt',
  'pricing.modal.comingSoon': 'Registrering og betalingsbehandling vil snart være tilgjengelig.',
  'pricing.modal.patience': 'Vi jobber for å gi deg en sikker og sømløs opplevelse. Vær tålmodig.',
  'pricing.modal.understood': 'Forstått',

  // FAQ
  'faq.title': 'FAQ',
  'faq.subtitle': 'Besvart ærlig og kritisk.',
  'faq.q1': 'Hva gjør IdeaOracle.ai konkret?',
  'faq.a1': 'IdeaOracle.ai vurderer forretningsidéer og nisjer for markedslogikk, reell etterspørsel, konkurranse, differensiering og gjennomførbarhet.\nHvis substans finnes, viser vi hvordan den kan skjerpes strategisk.\nHvis ikke, sier vi det.',
  'faq.q2': 'Genererer dere også idéer?',
  'faq.a2': 'Ja.\nMen ikke blindt.\nVi utvikler tilnærminger basert på markedslogikk – ikke motivasjon eller trendhype.',
  'faq.q3': 'Optimaliserer dere forretningsmodeller?',
  'faq.a3': 'Ja – hvis potensial finnes.\nVi polerer ikke illusjoner.\nVi gjør levedyktige konsepter mer motstandsdyktige.',
  'faq.q4': 'Hva skiller dere fra andre AI-verktøy?',
  'faq.a4': 'Andre verktøy leverer inspirasjon.\nVi leverer vurdering.\nFokuset ligger på realisme, ikke entusiasme.',
  'faq.q5': 'Er dette en garanti for suksess?',
  'faq.a5': 'Nei.\nVi reduserer feilbeslutninger – vi eliminerer ikke risiko.',
  'faq.q6': 'Hvem er IdeaOracle.ai for?',
  'faq.a6': 'Grunnleggere før lansering\nEntreprenører før ekspansjon\nSide-builders før tidsinvestering\nInvestorer før vurdering\n\nKort sagt: For mennesker som vil ha klarhet før kapital.',
  'faq.q7': 'Hva om jeg bare søker bekreftelse?',
  'faq.a7': 'Da er IdeaOracle.ai ikke riktig verktøy.',
  'faq.q8': 'Hvor ærlig er analysen?',
  'faq.a8': 'Så ærlig som data og markedsmekanikk tillater.\nIngen eufori. Ingen skånsel.',
  'faq.q9': 'Erstatter dere markedsundersøkelser?',
  'faq.a9': 'Nei.\nVi er en strategisk forhåndsvurdering – ikke en fullstendig markedsstudie.',
  'faq.q10': 'Hvorfor så kompromissløse?',
  'faq.a10': 'Fordi å mislykkes er dyrt.\nÆrlighet er det ikke.',

  // Footer
  'footer.description': 'Denne plattformen hjelper deg ikke å føle deg bra – men å ta riktige beslutninger.',
  'footer.product': 'Produkt',
  'footer.aiAssistant': 'AI-assistent',
  'footer.howItWorks': 'Hvordan det fungerer',
  'footer.pricing': 'Priser',
  'footer.faq': 'FAQ',
  'footer.legal': 'Juridisk',
  'footer.privacy': 'Personvern',
  'footer.terms': 'Vilkår',
  'footer.imprint': 'Impressum',
  'footer.support': 'Støtte',
  'footer.contact': 'Kontakt',
  'footer.documentation': 'Dokumentasjon',
  'footer.copyright': '© 2025 IdeaOracle.ai. Alle rettigheter reservert.',

  // AI Assistant
  'aiAssistant.title': 'AI-nisjeassistent',
  'aiAssistant.subtitle': 'Spørsmål om nisjer',
  'aiAssistant.welcomeMessage': 'Hei! Beskriv ideen din eller spør meg om en nisje. Jeg gir deg en klar og ærlig vurdering.',
  'aiAssistant.demoResponse': 'Dette er en demo. For å få ekte AI-vurderinger, registrer deg og velg en plan.',
  'aiAssistant.placeholder': 'Beskriv ideen din...',

  // Header & Sidebar
  'dashboard.header.title': 'Dashbord',
  'dashboard.sidebar.overview': 'Oversikt',
  'dashboard.sidebar.newAnalysis': 'AI-assistent',
  'dashboard.sidebar.history': 'Historikk',
  'dashboard.sidebar.credits': 'Kreditter',
  'dashboard.sidebar.settings': 'Innstillinger',

  // Dashboard Overview
  'dashboard.overview.welcome': 'Velkommen tilbake, {{name}}',
  'dashboard.overview.subtitle': 'Her er en rask oversikt over aktiviteten din',

  // Dashboard Stats
  'dashboard.stats.creditsRemaining': 'Gjenværende kreditter',
  'dashboard.stats.totalAnalyses': 'Totale analyser',
  'dashboard.stats.goodRatings': 'Positive vurderinger',
  'dashboard.stats.nextReset': 'Neste tilbakestilling om',
  'dashboard.stats.days': 'dager',

  // Quick Actions
  'dashboard.quickActions.title': 'Hurtighandlinger',
  'dashboard.quickActions.checkNewIdea': 'Sjekk en idé',
  'dashboard.quickActions.checkNewIdeaDesc': 'Analyser en eksisterende forretningsidé',
  'dashboard.quickActions.generateIdea': 'Generer en idé',
  'dashboard.quickActions.generateIdeaDesc': 'Finn en ny lønnsom nisje',
  'dashboard.quickActions.builderBriefing': 'Builder-briefing',
  'dashboard.quickActions.builderBriefingDesc': 'Gjør en idé om til en utviklerklar briefing',
  'dashboard.quickActions.premiumOnly': 'Kun Builder',

  // Chat Header
  'chat.title': 'AI-nisjeassistent',
  'chat.subtitle': 'Still spørsmål om nisjer. Jeg vurderer kritisk og ærlig.',
  'chat.creditsLabel': 'Kreditter',

  // Chat Welcome
  'chat.welcomeTitle': 'Velkommen til AI-nisjeassistenten',
  'chat.welcomeDesc': 'Beskriv ideen din eller spør om en nisje. Jeg vurderer ærlig: God, Middels eller Dårlig.',
  'chat.aiWelcome': 'Hei! Beskriv ideen din eller spør meg om en nisje. Jeg gir deg en klar og ærlig vurdering.',

  // Chat Suggestions
  'chat.suggestion1': 'Finn en lønnsom nisje for meg.',
  'chat.suggestion2': 'Jeg har en idé – vurder den ærlig.',
  'chat.suggestion3': 'Hvilke nisjer har potensial nå?',
  'chat.suggestion4': 'Forfin denne nisjen og gjør den mer spesifikk.',

  // Chat Actions
  'chat.newConversation': 'Ny samtale',
  'chat.today': 'I dag',
  'chat.yesterday': 'I går',
  'chat.thisWeek': 'Denne uken',
  'chat.thisMonth': 'Denne måneden',
  'chat.older': 'Eldre',
  'chat.messages': 'meldinger',
  'chat.renameConversation': 'Gi nytt navn',
  'chat.deleteConversation': 'Slett',
  'chat.cancel': 'Avbryt',
  'chat.rename': 'Gi nytt navn',
  'chat.delete': 'Slett',
  'chat.favorite': 'Legg til favoritt',
  'chat.unfavorite': 'Fjern favoritt',
  'chat.searchSessions': 'Søk samtaler...',
  'chat.noResults': 'Ingen resultater funnet',
  'chat.noSessions': 'Ingen samtaler ennå',
  'chat.enterNewName': 'Skriv inn nytt navn...',
  'chat.deleteConfirmMessage': 'Er du sikker på at du vil slette denne samtalen? Denne handlingen kan ikke angres.',

  // Chat Input & Errors
  'chat.inputPlaceholder': 'Skriv spørsmålet ditt… (koster 30 kreditter)',
  'chat.send': 'Send',
  'chat.voice': 'Snakk',
  'chat.listeningPlaceholder': 'Jeg lytter... Snakk nå.',
  'chat.stopListening': 'Stopp opptak',
  'chat.recording': 'Tar opp...',
  'chat.speechNotSupported': 'Talegjenkjenning støttes ikke av nettleseren din.',
  'chat.microphonePermissionDenied': 'Mikrofontilgang ble nektet. Tillat tilgang i nettleserinnstillingene dine.',
  'chat.errorNotEnoughCredits': 'Ikke nok kreditter. Oppgrader planen din eller vent på neste tilbakestilling.',
  'chat.errorAiFailed': 'AI-svar mislyktes. Ingen kreditter ble trukket.',
  'chat.errorRateLimit': 'For mange forespørsler. Vent et øyeblikk.',

  // Ratings
  'rating.good': 'God',
  'rating.medium': 'Middels',
  'rating.bad': 'Dårlig',

  // Auth Page
  'auth.branding.headline1': 'Ikke hver idé er god.',
  'auth.branding.headline2': 'Vi forteller deg ærlig hvilken.',
  'auth.branding.subtitle': 'En beslutnings-AI for forretningsnisjer. Klar. Kritisk. Uten omsvøp.',
  'auth.benefits.privacy.title': '100% Privat',
  'auth.benefits.privacy.desc': 'Ideene dine forblir helt private og sikre.',
  'auth.benefits.honest.title': 'Ærlig AI',
  'auth.benefits.honest.desc': 'Uten omsvøp – bare klar, kritisk tilbakemelding.',
  'auth.benefits.fast.title': 'Raske Resultater',
  'auth.benefits.fast.desc': 'Få klarhet om nisjen din på minutter.',
  'auth.trust.users': 'Aktive Brukere',
  'auth.trust.ideas': 'Analyserte Idéer',
  'auth.trust.rating': 'Vurdering',
  'auth.login.title': 'Logg inn',
  'auth.login.headline': 'Velkommen tilbake',
  'auth.login.subtitle': 'Logg inn for å fortsette reisen din.',
  'auth.login.forgotPassword': 'Glemt passord?',
  'auth.login.submit': 'Logg inn',
  'auth.login.noAccount': 'Ingen konto ennå?',
  'auth.login.signUp': 'Registrer deg',
  'auth.register.title': 'Registrer',
  'auth.register.headline': 'Opprett kontoen din',
  'auth.register.subtitle': 'Begynn å analysere forretningsideene dine i dag.',
  'auth.register.submit': 'Opprett Konto',
  'auth.register.hasAccount': 'Har du allerede en konto?',
  'auth.register.signIn': 'Logg inn',
  'auth.fields.name': 'Fullt Navn',
  'auth.fields.email': 'E-postadresse',
  'auth.fields.password': 'Passord',
  'auth.fields.confirmPassword': 'Bekreft Passord',
  'auth.fields.selectPlan': 'Velg planen din',
  'auth.placeholders.name': 'Skriv inn navnet ditt',
  'auth.placeholders.email': 'Skriv inn e-posten din',
  'auth.placeholders.password': 'Skriv inn passordet ditt',
  'auth.placeholders.confirmPassword': 'Bekreft passordet ditt',
  'auth.terms.accept': 'Jeg aksepterer',
  'auth.terms.terms': 'Vilkårene',
  'auth.privacy.accept': 'Jeg aksepterer',
  'auth.privacy.policy': 'Personvernreglene',
  'auth.errors.nameRequired': 'Navn er påkrevd',
  'auth.errors.emailRequired': 'E-post er påkrevd',
  'auth.errors.emailInvalid': 'Vennligst skriv inn en gyldig e-post',
  'auth.errors.passwordRequired': 'Passord er påkrevd',
  'auth.errors.passwordLength': 'Passordet må være minst 8 tegn',
  'auth.errors.passwordMismatch': 'Passordene stemmer ikke overens',
  'auth.loading': 'Vennligst vent...',
  'auth.or': 'eller fortsett med',
  'auth.social.google': 'Fortsett med Google',
  'auth.social.apple': 'Fortsett med Apple',

  // Trial Plan
  'pricing.trial.name': 'Trial',
  'pricing.trial.description': '3 dagers gratis tilgang',
  'pricing.trial.credits': '250 kreditter',
  'pricing.trial.free': 'Gratis',
  'pricing.trial.duration': 'Ingen kostnad i 3 dager',
  'pricing.trial.cta': 'Start gratis prøveperiode',
  'pricing.trial.feature1': '250 kreditter for å utforske AI-en',
  'pricing.trial.feature2': 'Full tilgang i 3 dager',
  'pricing.trial.feature3': 'Ingen kredittkort nødvendig',
  'pricing.trial.feature4': 'Avbryt når som helst',

  // Gold Package
  'pricing.gold.name': 'Gold',
  'pricing.gold.description': '10 000 kreditter + 25-siders Builder-rapport',
  'pricing.gold.credits': '10 000 kreditter',
  'pricing.gold.feature1': '10 000 kreditter',
  'pricing.gold.feature2': '25-siders Builder-rapport',
  'pricing.gold.feature3': 'Alle Starter- og Pro-funksjoner',
  'pricing.gold.feature4': 'Markedsanalyse og sammendrag',
  'pricing.gold.feature5': 'Muligheter, risiko, anbefalinger',
  'pricing.gold.feature6': 'Last ned PDF',
  'pricing.gold.feature7': 'Støtte',

  // Platinum Package
  'pricing.platinum.name': 'Platinum',
  'pricing.platinum.description': '15 000 kreditter + 100-siders Builder-rapport',
  'pricing.platinum.credits': '15 000 kreditter',
  'pricing.platinum.feature1': '15 000 kreditter',
  'pricing.platinum.feature2': '100-siders Builder-rapport',
  'pricing.platinum.feature3': 'Alle Gold-funksjoner',
  'pricing.platinum.feature4': 'Builder-modus: utviklerbriefinger',
  'pricing.platinum.feature5': 'Strukturert sammendrag',
  'pricing.platinum.feature6': 'Avansert markedsanalyse',
  'pricing.platinum.feature7': 'Støtte',

  // Pricing UI
  'pricing.monthly': 'Månedlig',
  'pricing.yearly': 'Årlig',
  'pricing.savings': 'spart',
  'pricing.billedYearly': 'Fakturert årlig',

  // Hero trial CTA
  'hero.trialTitle': 'Start din gratis prøveperiode',
  'hero.creditsLabel': 'Kreditter',
  'hero.trialTagline': 'Prøv vår AI-assistent gratis i 3 dager',
  'hero.trialCta': 'Registrer deg & få 250 kreditter',
  'hero.trialNoCard': 'Ingen kredittkort nødvendig. Ingen forpliktelse.',

  // Admin
  'admin.dashboard.tabs.plans': 'Planer',

  // Credit top-up
  'dashboard.credits.topup.button': 'Fyll på kreditter',
  'dashboard.credits.topup.buttonTitle': 'Kjøp flere kreditter uten å bytte plan',
  'dashboard.credits.topup.title': 'Fyll på kreditter',
  'dashboard.credits.topup.subtitle': 'CHF 0,15 per kreditt — ingen planendring nødvendig',
  'dashboard.credits.topup.quickAmounts': 'Hurtigvalg',
  'dashboard.credits.topup.custom': 'Egendefinert',
  'dashboard.credits.topup.totalLabel': 'Totalt',
  'dashboard.credits.topup.creditsLabel': 'Kreditter',
  'dashboard.credits.topup.confirm': 'Kjøp nå',
  'footer.disclaimer': 'Ansvarsfraskrivelse',
  'legal.backToHome': 'Tilbake til startsiden',
  'legal.lastUpdated': 'Sist oppdatert',
  'legal.allRightsReserved': 'Alle rettigheter forbeholdt.',
  'legal.authoritativeNotice': 'En lokalisert versjon på ditt språk er ikke tilgjengelig ennå. Den engelske, autoritative teksten vises nedenfor.',
  'legal.translationNotice': 'Dette er en oversettelse for enkelhets skyld. Den engelske versjonen er det juridisk bindende originalen.',
};

export default common;
